/*document.addEventListener("contextmenu", function (e){
    e.preventDefault();
}, false);*/

$( document ).ready(function() {
  
$(".st-wish-det").click(function(){
  setTimeout(function(){
    const count = document.querySelectorAll('.st-product-card').length;
    //console.log(count);    
    document.getElementById('box-count').innerText = count;
    }, 3000);

  $('#box-count').addClass('active');
});

$("#rewardsbtn .pabs.active").click(function(){
  $('.pabs').removeClass('active');
  $('.loloyal-iframe-page').addClass('loloyal-iframe-page-open');
  $('.loloyal-iframe-page').removeClass('loloyal-iframe-page-close'); 
  $('.loloyal-iframe-page').show();
});  
  

$("#rewardsbtn .prel,.loloyal-close").click(function(){
  $('.pabs').addClass('active');
  $('.loloyal-iframe-page').addClass('loloyal-iframe-page-close'); 
  $('.loloyal-iframe-page').removeClass('loloyal-iframe-page-open');
  $('.loloyal-iframe-page').hide();
}); 

  /*setTimeout(function(){
    var parent = document.getElementById("st-wishlist");
    var nodesSameClass = parent.getElementsByClassName("st-product-card");
    console.log(nodesSameClass.length);
}, 10000);*/
});
/*
// Function to update count and display it
function updateCount() {
    const count = document.querySelectorAll('.st-product-card').length;
    //document.getElementById('box-count').innerText = count;
  console.log(count);
}


// Call updateCount() initially to display the initial count
updateCount();

// Observer to watch for changes in the container
const observer = new MutationObserver(mutationsList => {
    for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
            updateCount();
        }
    }
});

// Start observing changes in the container
const container = document.querySelector('.st-wishlist-details');
observer.observe(container, { childList: true });

*/

